/**
 * @file: msg.js
 * @description: 消息存储
 */
import WebSocketManager from "@/utils/socket.js";
import { Notification } from 'element-ui';
import router from '@/router';
import { getPlatform } from '@tencentcloud/universal-api';
import myJsTools from '@/utils/myJsTools';

const state = {
  wsConnected: false, // WebSocket 连接状态
  wsManager: null, // WebSocket 管理器实例
  msgList: [],
  componentCallbacks: {},
  soundConfig: false,
  audio: null,
  audioListener: null, // 存储当前的交互监听器
  latestMsgType: ''
};

const ALLOWED_SOUND_TYPES = [
  'new_order_remind',    // 新单提醒
  // 'prescription_reject_remind', // 处方被驳回
  'prescription_wait_audit_remind' // 处方待审核
];

const mutations = {
  __VUEX_MY_PERSISTEDSTATE_SET__(state, { key, value }) {
    state[key] = value;
  },
  // 设置 WebSocket 连接状态
  SET_WS_STATUS(state, status) {
    state.wsConnected = status;
  },
  // 设置 WebSocket 管理器实例
  SET_WS_MANAGER(state, manager) {
    // 使用 Object.defineProperty 将 WebSocket 管理器设为不可枚举，避免 Vue 响应式系统跟踪
    Object.defineProperty(state, "wsManager", {
      value: manager,
      writable: true,
      enumerable: false,
      configurable: true,
    }); 
  },
  // push消息
  PUSH_MSG(state, msg) {
    msg && state.msgList.push(msg)
  },
  // 移除消息
  REMOVE_MSG(state, msg) {
    state.msgList = state.msgList.filter(item => item.regId !== msg.regId);
  },
  // 跳转路由时移除某个类型的消息
  CLOSE_MSG(state, msgType) {
    state.msgList.forEach(msg => {
      msg.messageType == msgType && msg.msgNotice.close();
    });
    state.msgList = []
  },
  // 注册点击消息的回调
  REGISTER_COMPONENT_CALLBACKS(state, methods) {
    state.componentCallbacks = {...state.componentCallbacks, ...methods};
  },
  // 更新声音配置
  UPDATE_SOUND_CONFIG(state, soundFlag) {
    console.log('test--->888', soundFlag)
    state.soundConfig = soundFlag;
  },
  SET_AUDIO(state, audio) {
    state.audio = audio;
  },
  // 在mutations中添加
  SET_AUDIO_LISTENER(state, listener) {
    state.audioListener = listener;
  },
  SET_LATEST_MSG_TYPE(state, type) {
    state.latestMsgType = type;
  }
};

const getters = {
  getMsgList(state) {
    return state.msgList
  }
};

const actions = {
  // 初始化 WebSocket 连接
  async initWebSocket({ commit, dispatch, state }, userId) {
    console.log("初始化 WebSocket连接，docId:", userId);
    if (!userId || userId === "null" || userId === "undefined") {
      console.error("WebSocket初始化失败: 缺少docId");
      return;
    }
    // 如果有实例，并且在链接状态，return
    if (
      state.wsManager &&
      state.wsManager.isConnected &&
      state.wsManager.isConnected()
    ) {
      return;
    }

    // 创建 WebSocket 管理器实例
    const wsManager = new WebSocketManager(userId);
    commit("SET_WS_MANAGER", wsManager);

    // 设置连接状态回调
    wsManager.setCallbacks({
      onOpen: function () {
        window.$tracker.send({
          message: '#NOTICE#消息提醒-websocket_open-socket连接',
          content: JSON.stringify({
            userId: userId
          })
        });
        commit("SET_WS_STATUS", true);
        // console.log("WebSocket连接成功");
      },
      onClose: function (event) {
        window.$tracker.send({
          message: '#NOTICE#消息提醒-websocket_close-socket断开',
          content: JSON.stringify({
            userId: userId,
            event: event
          })
        });
        commit("SET_WS_STATUS", false);
        // console.log("WebSocket连接关闭");
      },
      onError: function (error) {
        window.$tracker.send({
          message: '#NOTICE#消息提醒-websocket_error-socket错误',
          content: JSON.stringify({
            userId: JSON.stringify(error)
          })
        });
        commit("SET_WS_STATUS", false);
        // console.error("WebSocket连接错误:", error);
      },
    });

    // 建立连接
    wsManager.connect();

    // 监听消息
    wsManager.onmessage((message) => {
      // 过滤心跳消息、连接成功的系统消息
      if (message.messageType && !["heartbeat", "system"].includes(message.messageType)) {
        dispatch("handleNewMessage", message);
      }
    });
  },
  // 关闭 WebSocket 连接
  closeWebSocket({ commit, dispatch, state }) {
    console.log("关闭 WebSocket连接");
    if (state.wsManager) {
      state.wsManager.close();
      // commit("SET_WS_MANAGER", null);
      commit("SET_WS_STATUS", false);
      dispatch('reset_msg');
      dispatch('pausePlayingAudio');
    }
  },
  // 处理新消息
  handleNewMessage({ commit, dispatch, state }, message) {
    if(!message.content) return;
    const msg = {
      ...message,
      content: JSON.parse(message.content || '{}')
    };
    commit('SET_LATEST_MSG_TYPE', message.messageType)
    console.log("test--->111处理新消息", msg, router);
    // 判断消息类型
    if([
      'new_order_remind', 
      'prescription_reject_remind', 
      'prescription_wait_audit_remind'
    ].includes(message.messageType)){
      console.log("test--->222处理新消息", msg);
      // 如果是 [新单提醒]、[处方驳回提醒]、[处方待审核提醒] 的消息类型，进行PC内提示、PC外提示、声音提醒
      dispatch('handleNoticeInside', msg);
      dispatch('handleNoticeOutside', msg);
      dispatch('handleNoticeSound', msg);
    } else {
      // [处方状态改变]、[问诊状态改变]不提示,且关闭刚才弹出的消息提示
      dispatch('clearAudioListeners'); // 先清除已有监听器
      dispatch('msgClose', msg);
    }
  },
  // PC内消息提醒
  async handleNoticeInside({ commit, dispatch, state }, message) {
    if(!message || !message.messageType) return;
    console.log("test--->333处理新消息", router.currentRoute.name, message);
    const curRouteName = router.currentRoute.name;
    // 新单消息在抢单区页面不提醒;
    if(['index', 'grabOrderList'].includes(curRouteName) && message.messageType === 'new_order_remind') return;
    // 处方待审核在待审核处方列表页面不提醒;
    if(curRouteName === 'trialPartyIndex' && message.messageType === 'prescription_wait_audit_remind') return;
    let customClass = getPlatform() === 'h5' ? 'message-notification-custom-class message-notification-custom-class-h5' : 'message-notification-custom-class';
    console.log("test--->440处理新消息", message, getPlatform(), customClass);

    const content = message.content;
    if(!content?.messageTitle || !content?.messageContent) return;

    const trackerObj = {
      message_id: content.redId,
      message_type: message.messageType,
      msg_id: message?.content?.regId || '未知',
      notice_type: 'PC内push消息'
    }

    const msgNotice = Notification.success({
        title: `${content?.messageTitle || '消息提醒'}`,
        message: `${content?.messageContent || '您有一条新消息'}`,
        showClose: true,
        duration: 3000,
        customClass,
        onClick: async () => {
          window.$tracker.send({
            message: '#NOTICE#消息提醒-notifications_click-消息点击',
            content: JSON.stringify(trackerObj)
          });
          msgNotice.close();
          dispatch('msgClick', message)
        },
        onClose: () => {
          window.$tracker.send({
            message: '#NOTICE#消息提醒-notifications_click-消息关闭',
            content: JSON.stringify(trackerObj)
          });
          commit('REMOVE_MSG', message)
        }
    });
    window.$tracker.send({
      message: '#NOTICE#消息提醒-notifications_push-消息展示',
      content: JSON.stringify(trackerObj)
    });
    commit('PUSH_MSG', {
      ...message, 
      noticeType: 'inside', 
      msgNotice
    });
  },
  // PC外消息提醒
  async handleNoticeOutside({ commit, dispatch }, message) {
    if(!message || !message.messageType) return;
    // 检查浏览器是否支持Notification API
    if (!("Notification" in window)) {
      return
    }
    // 获取当前用户权限
    let permission = window?.Notification?.permission;
    // 未询问，则询问用户
    if (permission === 'default') {
      window.Notification.requestPermission(function (res) {
        permission = res;
      });
    };
    // 判断权限
    if (permission === "granted") {
      // 监听页面可见性变化
      let isPageVisible = document.visibilityState === 'visible';
      document.addEventListener('visibilitychange', () => {
        isPageVisible = document.visibilityState === 'visible';
      });
      if(isPageVisible) return;

      // 创建通知
      let msgNotice = null;
      const content = message.content;
      if(!content?.messageTitle || !content?.messageContent) return;

      const trackerObj = {
        message_id: content.redId,
        message_type: message.messageType,
        msg_id: message?.content?.regId || '未知',
        notice_type: 'PC外桌面消息'
      }

      msgNotice = new window.Notification(`${content?.messageTitle || '消息提醒'}`, { 
        body: `${content?.messageContent || '您有一条新消息'}`,
        requireInteraction: true 
      });
      commit('PUSH_MSG', {
        ...message, 
        noticeType: 'outside', 
        msgNotice
      });
      window.$tracker.send({
        message: '#NOTICE#消息提醒-notifications_push-消息展示',
        content: JSON.stringify(trackerObj)
      });
      // 3S后关闭提示
      const timer = setTimeout(() => {
        msgNotice.close();
        timer && clearTimeout(timer);
      }, 3000);
      // 3S后自动关闭或者手动关闭，都会触发回调
      msgNotice.onclose = function () {
        timer && clearTimeout(timer);
        window.$tracker.send({
          message: '#NOTICE#消息提醒-notifications_click-消息关闭',
          content: JSON.stringify(trackerObj)
        });
        commit('REMOVE_MSG', message);
      }
    } else {
      console.log('用户拒绝了通知授权')
    }
  },
  // 声音提醒
  async handleNoticeSound({ commit, dispatch, state }, message) {
    if(!message || !message.messageType) return;
    const content = message.content;
    if(!content?.messageTitle || !content?.messageContent) return;
    // 播放前停止其它音频的播放
    if(['new_order_remind', 'prescription_wait_audit_remind', 'prescription_reject_remind'].includes(message.messageType)) {
      dispatch('pausePlayingAudio')
    };
    console.log('test--->666000>>声音',myJsTools.getItem("docAllInfo")?.voiceSwitch == '1', state.soundConfig, state, message)
    // 新单提醒和处方待审核提醒，才查询声音开关配置 只处理需要声音提醒的消息类型
    const needSound = ['new_order_remind', 'prescription_wait_audit_remind'].includes(message.messageType) && state.soundConfig;
    console.log('test--->666111>>声音', needSound);
    if (!needSound && message.messageType !== 'prescription_reject_remind') {
      // 清除可能存在的残留监听器
      dispatch('clearAudioListeners');
      return;
    }
      // ------------------------- 播放消息提示音频 ---------------------------
      // 为当前消息创建唯一标识
      const audioId = `audio_${Date.now()}`;
      const sound = new Audio(require("@/assets/audio/notice.mp3"));
      sound.currentTime = 0;
      sound.loop = message.messageType !== 'prescription_reject_remind';
      sound.volume = 1;
      sound.muted = false; 
      // 保存音频实例和对应的消息类型
      commit('SET_AUDIO', {
        instance: sound,
        messageType: message.messageType,
        audioId
      });
      const trackerObj = {
        message_id: content.redId,
        message_type: message.messageType,
        msg_id: message?.content?.regId || '未知',
        notice_type: '声音提醒'
      }
      try {
        await state.audio?.instance.play();
        window.$tracker.send({
          message: '#NOTICE#消息提醒-notifications_play-声音播放',
          content: JSON.stringify(trackerObj)
        });
      } catch (error) {
          console.log('test--->666222000>>声音',state.soundConfig, error);
          window.$tracker.send({
            message: '#NOTICE#消息提醒-notifications_play-未交互声音播放失败',
            content: JSON.stringify(trackerObj)
          });
          // 监听用户交互事件，一旦有交互就播放
          const playOnUserInteraction = () => {
            // if(!state.soundConfig) return 
            console.log('test--->666222111>>声音',state.soundConfig, state.audio, state.audio?.messageType, message.messageType)
            // 验证当前音频实例是否仍为当前消息对应的实例且需要声音
            if (state.audio?.audioId === audioId && 
                state.audio?.messageType === message.messageType && 
                state.soundConfig &&
                ALLOWED_SOUND_TYPES.includes(state.latestMsgType)
            ) {
              console.log('test--->666333>>声音',!state.soundConfig, state.audio?.messageType, message.messageType)
              state.audio.instance?.play().catch((err) => {
                console.error('用户交互后播放音频失败:', err.message);
              });
              window.$tracker.send({
                message: '#NOTICE#消息提醒-notifications_play-交互后消息声音播放',
                content: JSON.stringify(trackerObj)
              });
              // 清除监听器
              dispatch('clearAudioListeners');
            }
            // 保存监听器引用以便后续清除
            commit('SET_AUDIO_LISTENER', playOnUserInteraction);
          };
          dispatch('clearAudioListeners'); // 先清除已有监听器
          document.addEventListener('keydown', playOnUserInteraction, { once: true });
          document.addEventListener('touchstart', playOnUserInteraction, { once: true });
          document.addEventListener('click', playOnUserInteraction, { once: true });
      }
      // ------------------------- 播放提示音频end ---------------------------
  },
  // 添加清除监听器的action
  clearAudioListeners({ commit, state }) {
    if (state.audioListener) {
      document.removeEventListener('keydown', state.audioListener);
      document.removeEventListener('touchstart', state.audioListener);
      document.removeEventListener('click', state.audioListener);
      commit('SET_AUDIO_LISTENER', null);
    }
  },
  // 注册消息的回调
  registerComponentCallback({ commit }, payload) {
    commit('REGISTER_COMPONENT_CALLBACKS', payload);
  },
  // 消息点击
  async msgClick({ commit, state }, message) {
    if(!message || !message.messageType) return;
    const curRouteName = router.currentRoute.name;
    // ---------------------------- 处方驳回的消息 ----------------------
    if(message.messageType === 'prescription_reject_remind') {
      console.log("test--->441处理新消息", message.content.regId);
      if(!message?.content?.regId) return;
      // PC/H5跳转到问诊中
      if(curRouteName !== 'index'){
        // step1 先跳转到在线诊室页面
        await state.componentCallbacks?.goTo('/index', '', {clickType: 'msg', msgId: message.content.regId});
      }
      // step2 先切换tab到[接诊中](appointment/index.vue)；注：这几个tab是写死的，所以index是固定写死的，如果后续添加tab或者更顺序，需要修改这里
      await state.componentCallbacks?.changeTab(2);
      // step3 再触发卡片的点击事件(appointment/card.vue)
      state.componentCallbacks?.openAddYy({
        clickType: 'msg',
        type: 2, // 0: 已预约, 1: 待接诊, 2: 接诊中, 3: 已结束
        regId: `${message.content.regId}`
      });
    }
    // ------------------------------- end -----------------------------

    // ---------------------------- 处方待审核的消息 ----------------------
    if(message.messageType === 'prescription_wait_audit_remind') {
      console.log("test--->442处理新消息", message, router);
      if(curRouteName !== 'trialPartyIndex'){
        // 切换到审方tab(src/common/tabbar.vue)
        await state.componentCallbacks?.goTo('/trialPartyIndex', '', {clickType: 'msg', msgId: message.content.regId});
      }
    }
    // ------------------------------- end -----------------------------

    // ------------------------------- 新单提醒 -------------------------
    if(message.messageType === 'new_order_remind') {
      console.log("test--->443处理新消息", message, router);
      if(curRouteName !== 'index'){
        // step1: PC/H5：跳转到在线诊室页面;
        await state.componentCallbacks?.goTo('/index', '', {clickType: 'msg', msgId: message.content.regId});
      }
    }
    // ------------------------------- end -----------------------------
  },
  // 消息关闭，停止声音，移除消息 
  msgClose({ commit, dispatch, state }, message) {
    if(!message || !message.messageType) return;
    // 问诊状态发生变化，使用regId匹配; 处方状态发生变化，使用prescriptionId匹配处方待审核的消息
    dispatch('pausePlayingAudio')
    commit('REMOVE_MSG', message);
  },
  // 开关关闭，停止声音
  async pausePlayingAudio({ commit, state}, message) {
    console.log('test--->999999',state.audio)
    if (state.audio?.instance) {
      state.audio.instance.pause();
    }
    // 同时清除监听器
    commit('SET_AUDIO_LISTENER', null);
  },
  reset_msg({commit, dispatch}) {
    commit('PUSH_MSG', null);
    commit('REGISTER_COMPONENT_CALLBACKS', {});
    dispatch('pausePlayingAudio')
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
